import { set } from 'lodash';
export function getAppParams(key) {
    const fields = ['env', 'projectId', 'branch'];
    const res = {};
    fields.forEach((k) => {
        set(res, k, window.RUNTIME_CONFIGS?.[k] || '');
    });
    if (key)
        return res[key] || '';
    return res;
}
;
